import { BankTxnStatus, SmbAttachmentStatus } from "@/apis/gql/types";
import type { RawFilters } from "@/hooks/useQueryFilters";

export const smbTransactionsTodosFilter: RawFilters<
  "smbAttachmentStatus" | "side"
> = {
  smbAttachmentStatus: [
    SmbAttachmentStatus.NOT_ATTACHED,
    SmbAttachmentStatus.ATTACHMENT_SUGGESTED,
    SmbAttachmentStatus.NOT_REQUIRED_SUGGESTED,
  ],
  side: "all",
};

export const accountingTransactionsTodosFilter: RawFilters<"status"> = {
  status: [BankTxnStatus.NOT_REVIEWED],
};

export const accountingTransactionsReadyToExportFilter: RawFilters<"status"> = {
  status: [BankTxnStatus.REVIEWED],
};
